// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__3S34L","main-page":"layout_main-page__18Gz6","fade-effect":"layout_fade-effect__3CyJV","fade":"layout_fade__2cL8Y"};